/**
 * The current page URL including the query string (filters, tab, page).
 * Pass it as `returnUrl` in the history state when leaving a list for an edit/add page,
 * so the edit page can redirect back to the list exactly as it was.
 */
export const getCurrentListUrl = () =>
	window.location.pathname + window.location.search;
